
const orderDetailsReducer = (state = {"services": [], "addons": [], "devices":[], "customerInfo": {}, "billingInfo": {}, "allServices":[],"installation":{},"saveOrderData":{},"onboardingRequest":{},"profileData":""}, action) => {
	if (action.type === 'SET_ORDER_DETAILS') {
		var newState = {};
		Object.assign(newState, state);
		// newState[action.key] = action.payload;
		insertDataIntoGivenPath(newState,action.key,action.payload);
		console.log("orderDetails newState >>", newState);
		return newState;
	} else {
		return state
	}
}

function insertDataIntoGivenPath(obj, props, newValue) {
	var propsArr = props.split('.');
	var prop = propsArr.splice(0, 1);
	var nextObject = obj[prop];
	if (!propsArr.join('.')) {
		return obj[prop] = newValue;
	} else {
		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
		return obj;
	}
}

export default orderDetailsReducer;
